module.exports = __webpack_public_path__ + "assets/img/SUGGEST.585340be.png";